namespace GeniuzPOS.PosShift {
    export class PsVatRefundRateColumns {
        static columnsKey = 'PosShift.PsVatRefundRate';
    }
}
